import * as Scrivito from "scrivito";
import { toHtmlId } from "^/utils/toHtmlId";
import { getKeycloak } from "^/Components/Authentication/keycloak";

export const Item = Scrivito.connect(({ item, currPage }) => {
  if (!item) {
    return <span className="inpage-navigation__link --inactive">---</span>;
  }

  if (item.objClass?.() === "Redirect") {
    const link = item.get("link");
    if (!link) {
      return (
        <a
          href="#"
          className="inpage-navigation__link"
          onClick={() =>
            getKeycloak().login({
              redirectUri: Scrivito.urlFor(item),
            })
          }
        >
          Login to Intranet
        </a>
      );
    }

    const external = link.isExternal();
    const title =
      link.title() || (external ? link.url() : link.obj()?.get("title"));

    return (
      <Scrivito.LinkTag
        to={link}
        className={`inpage-navigation__link --inactive`}
      >
        {title}
      </Scrivito.LinkTag>
    );
  }

  return (
    <Scrivito.LinkTag
      to={item}
      className={`inpage-navigation__link ${
        currPage?.id() === item.id() ? "--active" : "--inactive"
      }`}
      title={item.get("title")}
    >
      {item.get("title")}
    </Scrivito.LinkTag>
  );
});

export const Items = Scrivito.connect(({ items, currPage }) =>
  items.map((item, index) => (
    <Item key={index} item={item} currPage={currPage} />
  ))
);

export const InternalItems = Scrivito.connect(({ items, _currPage }) =>
  items.map((item) => (
    <a href={`#${toHtmlId(item.get("anchor"))}`} key={item.id()}>
      {item.get("anchor")}
    </a>
  ))
);
